import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Api} from "../../../../../../common/services/api.service";
import {Api3Service} from "../../../../../../common/services/api3.service";
import {ToastService} from "../../../../../../common/services/toast.service";
import {SpinnerService} from "../../../../../../common/services/spinner.service";
import {Modal} from "../../../../../services/modal.service";

@Component({
    selector: "section-logivice-v3-webhook-hosts-form",
    templateUrl: "form.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogiviceV3WebhookHostsFormComponent implements OnInit {

    public modal: Modal.IModal;

    public formGroup: FormGroup = new FormGroup({
        type: new FormControl("LogiviceV3", [Validators.required]),
        name: new FormControl(null, [Validators.required]),
        value: new FormControl(null, [Validators.required]),
        is_active: new FormControl(true),
    });

    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private api3Service: Api3Service,
        private toastService: ToastService,
        private spinnerService: SpinnerService
    ) {
    }

    public async submitForm(): Promise<any> {
        this.spinnerService.show();

        let res: Api.IResponse;

        if (this.modal.params.data) {
            res = await this.api3Service.put(
                `${this.modal.params.state.section}/whitelist-ips/${this.modal.params.data.id}`,
                this.formGroup.value
            );
        } else {
            res = await this.api3Service.post(
                `${this.modal.params.state.section}/whitelist-ips`,
                this.formGroup.value
            );
        }

        this.spinnerService.hide();

        if (res.code === 200) {
            this.toastService.show(res.message, "success");
            this.close();
        }
    }

    public close(): void {
        this.modal.response.next({
            value: true,
            name: "res"
        });
    }

    public ngOnInit(): void {
        if (this.modal.params.data) {
            this.formGroup.patchValue(this.modal.params.data);
        }
        this.changeDetectorRef.markForCheck();
    }
}
